module.exports = __webpack_public_path__ + "media/icons/modal_close-860909d7.svg";